export default __webpack_public_path__ + "static/media/NIAS0130.34I-32733_-17892_0.54c870c7.jpg";